import Marionette from "marionette";
import RunnedAppItemView from "./RunnedAppItemView";
import template from "apps/RunnedApps/view/template/RunnedAppsView.html";
import "css!apps/RunnedApps/view/css/RunnedAppsView";


let RunnedAppsView = Marionette.CompositeView.extend("RunnedAppsView", {
    template,
    childView: RunnedAppItemView,
    childViewContainer: ".RunnedAppsView--container",
    className: "RunnedAppsView theme-background-color",
    childEvents: {
        show: "onShowItem",
        close: "onCloseItem"
    },

    ui: {
        $closeAll: ".RunnedAppsView--closeAll",
        $minAll: ".RunnedAppsView--minAll"
    },

    events: {
        "click @ui.$closeAll": "onClickCloseAll",
        "click @ui.$minAll": "onClickMinAll"
    },

    onShowItem(view) {
        this.trigger("showApp", view.model);
    },

    onCloseItem(view) {
        this.trigger("closeApp", view.model);
    },

    onClickCloseAll() {
        this.collection.each(function(model) {
            setTimeout(function() {
                this.trigger("closeApp", model);
            }.bind(this));
        }.bind(this));
    },

    onClickMinAll() {
        this.collection.each(function(model) {
            this.trigger("minApp", model);
        }.bind(this));
    }
});

export default RunnedAppsView;
